module.exports = __webpack_public_path__ + "img/bn0711.00159c0e.png";